import { useState } from 'react';
import { config } from '../config/env';
import { buildConnectUrl, buildClaudeCodeSnippet,buildCodexSnippet, buildMcpJsonSnippet } from '../lib/mcp-connect';

interface ConnectPanelProps {
  agentName: string;
  // Omit for an agent-level connect (all of the agent's resources via the
  // unified endpoint) rather than a single resource.
  resourceName?: string;
  agentRoutingEnabled: boolean;
}

const CopyableBlock = ({ label, value }: { label: string; value: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API can fail (permissions, insecure context) — the text
      // is still visible and selectable, so there's nothing further to do.
    }
  };

  return (
    <div className="connect-block">
      <div className="connect-block-header">
        <span className="connect-block-label">{label}</span>
        <button className="link-button" onClick={handleCopy}>
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <pre className="connect-code">
        <code>{value}</code>
      </pre>
    </div>
  );
};

export const ConnectPanel = ({ agentName, resourceName, agentRoutingEnabled }: ConnectPanelProps) => {
  const connectUrl = buildConnectUrl(config.gatewayUrl, agentName, resourceName, agentRoutingEnabled);

  return (
    <div className="connect-panel">
      <CopyableBlock label="URL" value={connectUrl} />
      <CopyableBlock
        label="Claude Code"
        value={buildClaudeCodeSnippet(resourceName, connectUrl, agentName, agentRoutingEnabled)}
      />
      <CopyableBlock
        label="Codex"
        value={buildCodexSnippet(resourceName, connectUrl, agentName, agentRoutingEnabled)}
      />
      <CopyableBlock
        label="mcpServers JSON (Cursor, VS Code, etc.)"
        value={buildMcpJsonSnippet(resourceName, connectUrl, agentName, agentRoutingEnabled)}
      />
      <p className="muted connect-hint">
        Your MCP client will prompt you to sign in with Okta the first time it
        connects.
      </p>
    </div>
  );
};
